import React, { Component } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import FrontNav from '../../components/FrontNav';
import TabNav from '../../components/TabNav';
import OrganisationList from '../../components/Organisation/OrgList';

class ScreenOrganisationsArtsmarkPartnerList extends Component {
	render () {
		return (
			<section>
				<Header />
				<FrontNav match={this.props.match} />
				<TabNav match={this.props.match} />
	    		<OrganisationList artsmarkPartner={1} />
	    		<Footer />
			</section>
		)
	}
}

export default ScreenOrganisationsArtsmarkPartnerList;